module.exports = __webpack_public_path__ + "static/media/TUNE_6620.a159d2ab.jpg";